/* @flow */
import styled from 'styled-components';

const coverSize = '144px';

const SliderSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  margin: 0 44px 8px 32px;
  font-size: ${props => props.theme.typography.fontSize.m};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  text-transform: uppercase;
`;

const ShowMoreButton = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

const Scroll = styled.div`
  display: flex;
  flex-direction: row;
  min-height: ${coverSize};
`;

const ScrollButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 36px;
  user-select: none;
`;

const Previous = styled.div`
  composes: scrollButton;
  background-color: ${props =>
    props.disabled ? props.theme.colors.medium : props.theme.colors.dark};
  margin-right: 3px;
`;

const Next = styled.div`
  composes: scrollButton;
  background-color: ${props =>
    props.disabled ? props.theme.colors.medium : props.theme.colors.dark};
  margin-left: 6px;
`;

const Albums = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  & > * {
    margin: 0px 3px;
  }
`;

const Centered = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const SliderWrapper = styled.div`
  padding-left: 32px;
  padding-right: 32px;
  margin-left: -8px;
`;

const SlideWrapper = styled.div`
  margin-left: 8px;
  margin-right: 8px;
`;

const GridSlider = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-row-gap: 16px;
`;

export default {
  SliderSection,
  Header,
  Title,
  ShowMoreButton,
  Scroll,
  ScrollButton,
  Previous,
  Next,
  Albums,
  Centered,
  SliderWrapper,
  SlideWrapper,
  GridSlider,
};
